import { useEffect, useRef } from 'react';
import { useIdle } from '@obv/ui';

// A wall display is never reloaded by hand, so it applies deploys itself: it polls build.json and,
// once a different build is live, reloads after the room has been idle for a while.
const CHECK_MS = 10 * 60_000;

export function isNewBuild(served: unknown, running: string): boolean {
  return !!served && typeof served === 'object' && typeof (served as { id?: unknown }).id === 'string' && (served as { id: string }).id !== running;
}

export function useReloadOnNewBuild(idleMs: number): void {
  const pending = useRef(false);
  useEffect(() => {
    if (!import.meta.env.PROD) return;
    const check = () =>
      fetch('/build.json', { cache: 'no-store' })
        .then((r) => (r.ok ? r.json() : null))
        .then((j: unknown) => {
          if (isNewBuild(j, __BUILD_ID__)) pending.current = true;
        })
        .catch(() => undefined);
    const t = setInterval(check, CHECK_MS);
    return () => clearInterval(t);
  }, []);
  useIdle(idleMs, () => {
    if (pending.current) window.location.reload();
  });
}
